import type { SvgProps } from 'react-native-svg';
import Svg, { Path } from 'react-native-svg';

import colors from '../colors';

export const Upload = ({ color = colors.neutral[500], ...props }: SvgProps) => (
  <Svg width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}>
    <Path
      d="M14 10v2.667c0 .353-.14.692-.39.942-.25.25-.59.391-.943.391H3.333c-.353 0-.693-.14-.943-.39A1.33 1.33 0 0 1 2 12.666V10"
      stroke={color}
      strokeWidth={1.333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M11.333 5.333 8 2 4.667 5.333"
      stroke={color}
      strokeWidth={1.333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M8 2v8"
      stroke={color}
      strokeWidth={1.333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
